(function () {
  function init(widget) {
    if (widget.dataset.ready) return;
    widget.dataset.ready = 'true';
    var variants = JSON.parse(widget.querySelector('[data-cvw-variants]').textContent);
    var cards = Array.from(widget.querySelectorAll('[data-cvw-card]'));
    var button = widget.querySelector('[data-cvw-btn]');
    var error = widget.querySelector('[data-cvw-error]');
    var purchase = widget.querySelector('[data-cvw-purchase]');
    var frequency = widget.querySelector('[data-cvw-frequency]');
    var planSelect = widget.querySelector('[data-cvw-plan]');
    var oneTime = purchase.querySelector('[value="one-time"]');
    var subscription = purchase.querySelector('[value="subscription"]');
    var stock = widget.querySelector('[data-cvw-stock]');
    var oneTimeOption = widget.querySelector('[data-cvw-one-time-option]');
    var subscriptionOption = widget.querySelector('[data-cvw-subscription-option]');
    var oneTimePrice = widget.querySelector('[data-cvw-one-time-price]');
    var subscriptionPrice = widget.querySelector('[data-cvw-subscription-price]');
    var subscriptionCompare = widget.querySelector('[data-cvw-subscription-compare]');
    var planUnavailable = widget.querySelector('[data-cvw-plan-unavailable]');
    var savingBenefit = widget.querySelector('[data-cvw-saving-benefit]');
    var savingPercent = widget.querySelector('[data-cvw-saving-percent]');
    var activeCard;
    var busy = false;

    function variantFor(card) {
      if (!card) return null;
      var material = card.querySelector('[data-cvw-select]');
      var id = material ? material.value : card.dataset.variantId;
      return variants.find(function (variant) { return variant.id === id; });
    }

    function plansFor(variant) {
      // Power is always one-time, even if a backend plan was assigned accidentally.
      return variant && /^(Radiant|Luminous) Oral Kit$/.test(activeCard.dataset.kitName) ? variant.plans : [];
    }

    function currentPlan(variant) {
      if (!subscription.checked) return null;
      return plansFor(variant).find(function (plan) { return plan.id === planSelect.value; }) || null;
    }

    function render() {
      var variant = variantFor(activeCard);
      var plan = currentPlan(variant);
      var previewPlan = plansFor(variant).find(function (item) { return item.id === planSelect.value; });
      oneTimePrice.textContent = variant ? variant.price : '';
      subscriptionPrice.textContent = previewPlan ? previewPlan.price : '';
      subscriptionCompare.textContent = previewPlan && variant ? variant.price : '';
      subscriptionCompare.hidden = !previewPlan;
      savingBenefit.hidden = !previewPlan;
      savingPercent.textContent = previewPlan ? previewPlan.discountPercent + '%' : '';
      oneTimeOption.classList.toggle('is-active', oneTime.checked);
      subscriptionOption.classList.toggle('is-active', subscription.checked);
      oneTimeOption.classList.toggle('is-disabled', oneTime.disabled);
      subscriptionOption.classList.toggle('is-disabled', subscription.disabled);
      frequency.hidden = !subscription.checked || purchase.hidden;
      var purchasable = variant && variant.available && (!variant.requiresPlan || plan) && (!subscription.checked || plan);
      button.disabled = busy || !purchasable;
      cards.forEach(function (card) {
        var cardVariant = variantFor(card);
        if (cardVariant) card.querySelector('.cvw__price').textContent = card === activeCard && plan ? plan.price : cardVariant.price;
      });
      button.textContent = busy ? 'Adding...' : (variant && !variant.available ? 'Sold out' : 'Add Your Bundle To Cart');
      if (!busy && variant) {
        button.appendChild(document.createTextNode(' – '));
        var price = document.createElement('span');
        price.dataset.cvwBtnPrice = '';
        price.textContent = plan ? plan.price : variant.price;
        button.appendChild(price);
      }
      stock.textContent = !variant ? 'Choose a kit' : !variant.available ? 'Sold out' : !purchasable ? 'This purchase option is unavailable' : 'In stock — Ready to ship';
    }

    function selectCard(card) {
  activeCard = card;

  cards.forEach(function (item) {
    item.classList.toggle('cvw__card--selected', item === card);
    item.querySelector('input[type="radio"]').checked = item === card;
  });

  var variant = variantFor(card);
  var plans = plansFor(variant);
  var previousPlan = planSelect.value;

  planSelect.replaceChildren();

  plans.forEach(function (plan) {
    var option = document.createElement('option');
    option.value = plan.id;
    option.textContent = plan.name;
    planSelect.appendChild(option);
  });

  if (plans.some(function (plan) {
    return plan.id === previousPlan;
  })) {
    planSelect.value = previousPlan;
  }

  purchase.hidden = !variant;

  var isSubscriptionKit = /^(Radiant|Luminous) Oral Kit$/.test(
    card.dataset.kitName
  );

  subscriptionOption.hidden = !isSubscriptionKit;
  planUnavailable.hidden = plans.length > 0;

  subscription.disabled = plans.length === 0;
  oneTime.disabled = !!(variant && variant.requiresPlan);

  // Always default Radiant / Luminous to subscription
  if (isSubscriptionKit && plans.length) {
    subscription.checked = true;
  } else {
    oneTime.checked = true;
  }

  error.style.display = 'none';
  render();

  if (variant) {
    document.dispatchEvent(
      new CustomEvent('cvw:variant-change', {
        detail: {
          variantId: variant.id,
          mediaId: variant.mediaId
        }
      })
    );
  }
}

    cards.forEach(function (card) {
      card.addEventListener('click', function (event) {
        if (event.target.closest('select')) return;
        selectCard(card);
      });
      card.querySelector('input[type="radio"]').addEventListener('change', function () { selectCard(card); });
      var material = card.querySelector('[data-cvw-select]');
      if (material) material.addEventListener('change', function () { selectCard(card); });
    });
    purchase.addEventListener('change', render);

    button.addEventListener('click', async function () {
      var variant = variantFor(activeCard);
      var plan = currentPlan(variant);
      if (busy || !variant || !variant.available || (variant.requiresPlan && !plan) || (subscription.checked && !plan)) return;
      // Use Shopify's allocated price; never apply a second frontend discount.
      var payload = { id: variant.id, quantity: 1 };
      if (plan) payload.selling_plan = plan.id;
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cart && cart.getSectionsToRender) {
        payload.sections = cart.getSectionsToRender().map(function (section) { return section.id; });
        payload.sections_url = window.location.pathname;
      }
      if (cart && cart.setActiveElement) cart.setActiveElement(button);
      busy = true;
      error.style.display = 'none';
      render();
      try {
        var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        var response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(payload)
        });
        var data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || 'Could not add to cart. Please try again.');
        if (cart && cart.renderContents) {
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        } else {
          window.location.assign(root + 'cart');
        }
      } catch (err) {
        error.textContent = err.message || 'Could not add to cart. Please try again.';
        error.style.display = 'block';
      } finally {
        busy = false;
        render();
      }
    });

   var initial =
  // Prefer Luminous on page load
  cards.find(function (card) {
    var variant = variantFor(card);
    return card.dataset.kitName === 'Luminous Oral Kit' &&
           variant &&
           variant.available;
  }) ||

  // Otherwise use Shopify's selected card
  cards.find(function (card) {
    return card.classList.contains('cvw__card--selected');
  }) ||

  // Otherwise first available card
  cards.find(function (card) {
    var variant = variantFor(card);
    return variant && variant.available;
  }) ||

  cards[0];

if (initial) selectCard(initial);
else render();
  }
  function initAll() { document.querySelectorAll('[data-cvw]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
